import { useMemo, useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { SortOrder, listFiltersService, ListTableSort } from "sprint-common-web";

export interface DistributorsListingFilters {
    page: number;
    pageSize: number;
    sortBy: string;
    sortOrder: SortOrder;
    name: string;
}

const defaultFilters: DistributorsListingFilters = {
    page: 1,
    pageSize: 50,
    sortBy: "updatedDate",
    sortOrder: "desc",
    name: ""
};

export const useDistributorsListingFilters = () => {
    const filtersService = useMemo(() => listFiltersService<DistributorsListingFilters>(defaultFilters), []);
    const location = useLocation();
    const history = useHistory();

    const [filters, setFilters] = useState<DistributorsListingFilters>(() =>
        filtersService.getSavedFilters(location.search)
    );

    useEffect(() => {
        filtersService.saveFilters(location.pathname, history, filters);
    }, [filters]);

    const setSort = (sort: ListTableSort): void => {
        setFilters((prevFilters: DistributorsListingFilters) => ({
            ...prevFilters,
            sortBy: sort.by,
            sortOrder: sort.order,
            page: 1
        }));
    };

    const setPage = (page: number): void => {
        setFilters((prevFilters: DistributorsListingFilters) => ({ ...prevFilters, page }));
    };

    const setPageSize = (pageSize: number): void => {
        setFilters((prevFilters: DistributorsListingFilters) => ({ ...prevFilters, pageSize, page: 1 }));
    };

    const setName = (name: string): void => {
        setFilters((prevFilters: DistributorsListingFilters) => ({ ...prevFilters, name, page: 1 }));
    };

    const clearFilters = (): void => {
        setFilters(defaultFilters);
    };

    return {
        filters,
        setName,
        setSort,
        setPage,
        setPageSize,
        clearFilters
    };
};
